import React, { useState } from "react";
import { FiMenu, FiSearch, FiBell, FiCalendar } from "react-icons/fi";
import { SideBarProps } from "../../Dto/menu";
import logo from "../../Assets/images/logo/camera-logo.svg";
import { useAppDispatch } from "../../Store/hooks";
import { clearAuthSlice } from "../../Store/authSlice";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogTitle, DialogContent, Typography, DialogActions, Button } from "@mui/material";
// import SuccessDialog from "../Common/SuccessDialog";



// const TopNavbar: React.FC<SideBarProps> = ({ openMenu, setOpenMenu }: SideBarProps) => (
export default function TopNavbar({ openMenu, setOpenMenu }: SideBarProps) {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
   const [dialogOpen, setDialogOpen] = useState(false);

  const handleLogoutClick = () => {
    setDialogOpen(true);
  };

  const handleLogout = () => {
    dispatch(clearAuthSlice());
    navigate("/");
    localStorage.removeItem("accessToken");
  };

    return (
        <nav
            className="navbar navbar-expand px-2 px-md-3 py-2 bg-white "
            style={{ minHeight: 56, zIndex: 100, position: 'sticky', top: 0 }}
        >
            {/* Left: Hamburger + Logo */}
            <div className="d-flex align-items-center flex-shrink-0">
                <button
                    className="btn p-0 me-2 me-md-3 d-md-none"
                    style={{ background: "none", border: "none", cursor: "pointer" }}
                    // onClick={toggleSidebar} // implement this if you want to toggle sidebar
                    onClick={() => {
                        console.log("test");
                        setOpenMenu()
                    }}
                    aria-label="Open sidebar"
                >
                    <FiMenu size={24} />
                </button>
                <span className="d-flex align-items-center"
                    onClick={() => { console.log("test"); setOpenMenu() }}
                    style={{ cursor: "pointer" }}>
                    <span
                    // style={{
                    //     background: "#E6F0FA",
                    //     borderRadius: 8,
                    //     padding: 6,
                    //     display: "flex",
                    //     alignItems: "center",
                    //     marginRight: 8,
                    // }}
                    >
                        {/* Logo SVG */}
                        {/* <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="20" height="18" rx="3" fill="#3498db" />
                            <rect x="4" y="5" width="12" height="2" fill="white" />
                            <rect x="4" y="8" width="12" height="2" fill="white" />
                            <rect x="4" y="11" width="12" height="2" fill="white" />
                        </svg> */}
                        <img
                            src={logo}
                            alt="logo"
                        // style={{
                        //     width: 36,
                        //     height: 36,
                        //     objectFit: "cover",
                        //     marginRight: 8,
                        // }}
                        />
                    </span>
                    <span className="fw-bold ms-2" style={{ fontSize: 20, color: "#222B45" }}>Logo</span>
                </span>
            </div>

            {/* Center: Search (hidden on mobile) */}
            <div className="d-none d-md-flex flex-grow-1 justify-content-center">
                <div
                    className="d-flex align-items-center"
                    style={{
                        background: "#FAFAFA",
                        borderRadius: 8,
                        padding: "0 16px",
                        width: 400,
                        height: 40,
                    }}
                >
                    <FiSearch size={18} color="#A3AED0" className="me-2" />
                    <input
                        type="text"
                        className="form-control border-0 bg-transparent p-0"
                        style={{ fontSize: 15, color: "#222B45" }}
                        placeholder="Search what you are looking for"
                    />
                </div>
            </div>

            {/* Right: Icons, Avatar, Logout */}
            <div className="d-flex align-items-center ms-auto flex-shrink-0">
                <FiCalendar size={22} color="#A3AED0" className="me-3 d-none d-md-inline" />
                <div className="position-relative me-3 d-none d-md-inline">
                    <FiBell size={22} color="#A3AED0" />
                    <span
                        style={{
                            position: "absolute",
                            top: -2,
                            right: -2,
                            width: 8,
                            height: 8,
                            background: "#FF5C5C",
                            borderRadius: "50%",
                            border: "2px solid #fff",
                        }}
                    />
                </div>
                <div className="dropdown d-flex align-items-center me-2 me-md-3">
                    <img
                        src="https://randomuser.me/api/portraits/men/32.jpg"
                        alt="avatar"
                        style={{
                            width: 36,
                            height: 36,
                            borderRadius: "50%",
                            objectFit: "cover",
                            marginRight: 8,
                            cursor: "pointer"
                        }}
                        // id="profileDropdown"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    />
                    <div className="d-none d-md-flex flex-column align-items-start" data-bs-toggle="dropdown"  style={{cursor: "pointer"}}>
                        <span style={{ fontSize: 12, color: "#A3AED0", lineHeight: 1 }}>Admin</span>
                        <span style={{ fontWeight: 600, fontSize: 15, color: "#222B45", lineHeight: 1 }}>Richard David</span>
                    </div>
                    <button
                        className="btn btn-link p-0 ms-1 d-none d-md-block"
                        type="button"
                        id="profileDropdown"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        style={{ color: "#222B45" }}
                    >
                        <svg width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M1.5 5.5l6 6 6-6" stroke="#222B45" strokeWidth="2" fill="none" strokeLinecap="round" />
                        </svg>
                    </button>
                    <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="profileDropdown">
                        <li><a className="dropdown-item" href="#">Profile</a></li>
                        <li><a className="dropdown-item" href="#">Settings</a></li>
                        <li><hr className="dropdown-divider" /></li>
                        <li><a className="dropdown-item" href="#">Logout</a></li>
                    </ul>
                </div>
               <button
          className="btn d-none d-md-block"
          style={{
            borderRadius: 8,
            fontWeight: 600,
            fontSize: 15,
            background: "var(--color-primary)",
            color: "var(--color-text-inverse)",
          }}
          onClick={handleLogoutClick}
        >
          Logout
        </button>
      </div>

     {/* Logout Confirmation Dialog */}
      <Dialog
  open={dialogOpen}
  onClose={() => setDialogOpen(false)}
  fullWidth
  maxWidth="xs"
  PaperProps={{
    sx: {
      borderRadius: 3,
      p: 2,
    },
  }}
>
  <DialogTitle
    sx={{
      fontWeight: 600,
      fontSize: 20,
      textAlign: "center",
      pb: 0,
      fontFamily: "Poppins, sans-serif",
    }}
  >
    Confirm Logout
  </DialogTitle>
  <DialogContent sx={{ textAlign: "center", mt: 1 }}>
    <Typography sx={{ fontSize: 16, fontFamily: "Open Sans, sans-serif" }}>
      Are you sure you want to logout?
    </Typography>
  </DialogContent>
  <DialogActions
    sx={{
      display: "flex",
      justifyContent: "center",
      gap: 2,
      mt: 2,
      pb: 2,
    }}
  >
    <Button
      onClick={() => setDialogOpen(false)}
      variant="outlined"
      color="primary"
      sx={{
        minWidth: 100,
        fontWeight: 600,
        borderRadius: 2,
        textTransform: "none",
      }}
    >
      NO
    </Button>
    <Button
      onClick={handleLogout}
      variant="contained"
      color="error"
      sx={{
        minWidth: 100,
        fontWeight: 600,
        borderRadius: 2,
        textTransform: "none",
      }}
    >
      YES
    </Button>
  </DialogActions>
</Dialog>

    </nav>
    );
}


